import { lazy } from "react";
import Loadable from "app/components/Loadable";

const CompanyInfo = Loadable(lazy(() => import("./CompanyInfo")));

const companyinfoRoute = [{ path: "/company-information", element: <CompanyInfo /> }];
export default companyinfoRoute;
